import { createContext } from "react";

export const PricesHandsontableContext = createContext(null);
